import { memo } from 'react';

import { Swap } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useSysadmin } from './SysadminProvider';

export const SysadminClearWorkspaceButton = memo(() => {
  const { handleClearWorkspaceId, isInternal } = useSysadmin();

  if (!isInternal) return null;

  return (
    <IconButton
      appearance="ghost"
      className="bg-black text-white hover:bg-black hover:text-white active:bg-black active:text-white"
      color="grey"
      icon={Swap}
      label="Switch"
      onClick={handleClearWorkspaceId}
    />
  );
});

SysadminClearWorkspaceButton.displayName = 'SysadminClearWorkspaceButton';
